<template>
  <div
    class="module"
    style="height: calc(100vh - 88px); background-color: #fff"
  >
    <div class="title">模块管理</div>
    <div class="addBtn" @click="addMoudle">创建</div>
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="name" label="模块名称"> </el-table-column>

        <el-table-column prop="create_at" label="创建时间">
          <template slot-scope="scope">
            <span>{{ scope.row.create_at | timeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序"> </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span>{{ scope.row.status == 0 ? "停用" : "正常" }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="operation" label="操作">
          <template slot-scope="scope">
            <el-button @click="editMoudle(scope.row)" type="text"
              >修改</el-button
            >
            <el-popconfirm
              :title="'确定停用该模块吗？'"
              @confirm="editMoudleClick(scope.row)"
              v-if="scope.row.status == 1"
            >
              <el-button slot="reference" style="color: #409eff" type="text"
                >停用</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              :title="'确定启用该模块吗？'"
              @confirm="editMoudleClick(scope.row)"
              v-if="scope.row.status == 0"
            >
              <el-button slot="reference" style="color: #409eff" type="text"
                >启用</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="pagination.total"
        @current-change="handleCurrentChange"
        :page-size="pagination.pageSize"
        :current-page="pagination.page"
      >
      </el-pagination>
    </div>

    <!-- 新增模块交流界面 -->
    <div class="add-moudle">
      <el-dialog
        title="新增模块"
        :visible.sync="addMoudleShow"
        width="30%"
        :before-close="handleClose"
      >
        <div class="dialog-content">
          <div class="content-item">
            <p>模块名称</p>
            <el-input v-model="name" placeholder="请输入内容"></el-input>
          </div>
          <div class="content-item">
            <p>排序</p>
            <el-input v-model="sorting" placeholder="请输入"></el-input>
          </div>
          <div class="content-item">
            <p>交流须知</p>
            <el-input
              type="textarea"
              :autosize="{ minRows: 4 }"
              placeholder="请输入内容"
              v-model="textarea"
              resize="none"
            >
            </el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addMoudleShow = false">取 消</el-button>
          <el-button type="primary" @click="confirmAdd">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
import "@/utils/timeFilter.js";
import {
  addMoudleApi,
  moudleListApi,
  moudleUpdateApi,
  moudleInfoApi,
} from "@/api/open";
export default {
  data() {
    return {
      pagination: {
        page: 1,
        total: 0,
        pageSize: 10,
      },
      inputHandle: {},
      sorting: "" /* 新增模块的排序 */,
      textarea: "" /* 新增模块的内容 */,
      name: "" /* 新增模块名字 */,
      addMoudleShow: false /* 控制新增模块显示 */,
      tableData: [],
    };
  },
  methods: {
    // //分页选择
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.moudleList();
    },
    // 启用模块
    editMoudleClick(row) {
      let parmas = {};
      if (row.status == 0) {
        parmas = {
          id: row.id,
          status: 1,
        };
      }
      if (row.status == 1) {
        parmas = {
          id: row.id,
          status: 0,
        };
      }
      moudleUpdateApi(parmas).then((res) => {
        this.$message.success(res.msg);
        this.moudleList();
      });
    },
    // 获取模块列表方法
    moudleList() {
      let parmas = {
        pageNum: this.pagination.page,
        pageSize: this.pagination.pageSize,
      };
      moudleListApi(parmas).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.tableData = res.data.list;
          this.pagination.page = res.data.pageNum;
          this.pagination.total = res.data.total;
          this.pagination.pageSize = res.data.pageSize;
        }
      });
    },
    // 修改模块方法
    moudleUpdate() {
      let parmas = {
        id: this.inputHandle.id,
        instruction: this.textarea,
        name: this.name,
        sort: this.sorting,
      };
      moudleUpdateApi(parmas).then((res) => {
        if (res.code == 200) {
          this.addMoudleShow = false;
          this.$message.success(res.msg);
          this.moudleList();
        }
      });
    },
    // 新增模块方法
    addMoudleFn() {
      let parmas = {
        name: this.name,
        instruction: this.textarea,
        status: 1,
        sort: this.sorting,
      };
      addMoudleApi(parmas).then((res) => {
        if (res.code == 200) {
          this.addMoudleShow = false;
          this.$message.success(res.msg);
          this.moudleList();
        }
      });
    },
    // 获取模块详情方法
    moudleInfo(id) {
      let parmas = {
        id: id,
      };
      moudleInfoApi(parmas).then((res) => {
        this.name = res.data.name;
        this.sorting = res.data.sort;
        this.textarea = res.data.instruction.replace(/<br\s*\/?>/gi,"\r\n");
        console.log( this.textarea);
        
      });
    },
    // 编辑页面
    editMoudle(row) {
      this.addMoudleShow = true;
      this.inputHandle = row;
      this.moudleInfo(row.id);
    },
    // 打开新增模块
    addMoudle() {
      this.inputHandle.id = "";
      this.name = "";
      this.sorting = "";
      this.textarea = "";
      this.addMoudleShow = true;
    },
    // 新增界面保存
    confirmAdd() {
      if (this.name == "") {
        Message({
          message: "模块名称不能为空",
          type: "error",
          customClass: "mzindex",
        });

        // this.$message.error("模块名称不能为空");
        return false;
      }
      if (this.sorting == "") {
        Message({
          message: "模块序号不能为空",
          type: "error",
          customClass: "mzindex",
        });
        // this.$message.error("模块序号不能为空");
        return false;
      }
      if (this.textarea == "") {
        Message({
          message: "交流须知不能为空",
          type: "error",
          customClass: "mzindex",
        });
        // this.$message.error("交流须知不能为空");
        return false;
      }
      if (this.inputHandle.id) {
        this.moudleUpdate();
      } else {
        this.addMoudleFn();
      }
    },
    handleClose() {
      this.addMoudleShow = false;
      this.moudleList();
    },
    handleClick(row) {
      console.log(row);
    },
  },
  mounted() {
    this.moudleList();
  },
};
</script>

<style lang="scss" scoped>
.module {
  padding: 10px 20px;
  position: relative;
  .title {
    color: rgba(102, 102, 102, 100);
    font-size: 20px;
    margin-bottom: 25px;
  }
  .addBtn {
    display: inline-block;
    padding: 5px 20px;
    margin-bottom: 10px;
    cursor: pointer;
    border: 1px solid #ccc;
  }
  .paging {
    text-align: right;
    margin-top: 10px;
  }

  // 新增页面样式
  .add-moudle {
    .dialog-content {
      .content-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        p {
          margin-right: 40px;
        }
        /deep/ .el-input {
          width: 260px;
        }
        /deep/ .el-textarea {
          width: 400px;
          resize: none;
        }
      }
      .content-item:nth-of-type(2) {
        p {
          margin-right: 68px;
        }
      }
    }
  }
}
</style>

<style>
.mzindex {
  z-index: 9999 !important;
}
</style>